import clsx from "clsx";
import { HTMLAttributes, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export interface SpinnerProps
  extends Omit<
    HTMLAttributes<SVGSVGElement>,
    "children" | "fill" | "viewBox" | "xmlns"
  > {
  size?: "sm" | "md" | "lg";
  variant?: "primary" | "secondary" | "light" | "dark";
}

const Spinner = forwardRef<SVGSVGElement, SpinnerProps>((props, ref) => {
  const { size = "md", variant = "primary", className, ...rest } = props;
  return (
    <svg
      {...rest}
      className={twMerge(
        clsx("fill-current animate-spin", {
          "w-4 h-4": size === "sm",
          "w-6 h-6": size === "md",
          "w-8 h-8": size === "lg",
          "text-primary": variant === "primary",
          "text-hunter-50": variant === "secondary",
          "text-gunmetal-50": variant === "light",
          "text-gunmetal-700": variant === "dark",
        }),
        className
      )}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        fillOpacity="0"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
});

export default Spinner;
